import styled, { css, keyframes } from "styled-components";

const fadeOutAnim = keyframes`
  0%{
    transition-timing-function: cubic-bezier(0.35, 0, 0.2, 1);
     transform: translateY(0);
     opacity:1;
    }
    100%{
      transform:translateY(123px);
      opacity:0;
   } 
`;
const fadeInAnim = keyframes`
      0% {
      transform: translate(0, 75px);
      opacity: 0;
    }
    10% {
      transition-timing-function: cubic-bezier(0.42, 0, 0.07, 0.92);
      transform: translate(0, 75px);
      opacity: 0;
    }
    50% {
      transition-timing-function: cubic-bezier(0.29, 0.2, 0.62, 1);
      transform: translate(0, -10px);
      opacity: 0.5;
    }
    100% {
      transform: translate(0,0);
      opacity: 1;
    } 
 `;

const fadeOut = css`
  ${fadeOutAnim} 0.55s 1 forwards
`;
const fadeIn = css`
  ${fadeInAnim} 0.55s 1 forwards
`;

export const HitsContainer = styled.div`
  animation: ${fadeIn};
  animation: ${(p) => (p.unBlur ? fadeOut : null)};
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  /* width: 100%; */
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(127, 61, 165, 0.85);

  & > div > div {
    position: relative;
    transform: translate3d(0, 0, 0);
    width: 320px;
    height: 630px;
    padding-bottom: 80px;
  }
  & > div > div > div {
    width: 320px;
    height: 620px;
    padding-bottom: 60px;
    overflow-y: scroll;
    -ms-overflow-style: none; // IE 10+
    scrollbar-width: none; // Firefox
    &::-webkit-scrollbar {
      display: none; // Safari and Chrome
    }
  }
`;

export const HitsBox = styled.div`
  padding-bottom: 30px;
`;
export const HitsDataBox = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 320px;
  text-align: center;
  margin: auto;
  padding: 10px 0;
`;
export const HitsHeading = styled.div`
  font-size: 20px;
  color: #ffb000;
  font-weight: bold;
  max-width: 320px;
  margin: auto;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  .TextRight {
    text-align: right;
  }
  .TextLeft {
    text-align: left;
  }
  span {
    width: 10%;
  }
  p {
    width: 40%;
  }
`;
export const HitsData = styled.div`
  color: #ffb000;
  width: 50%;
  /* margin: 0 10px; */
  ${(p) =>
    p.right
      ? "text-align:right;   padding-right: 17px;"
      : "text-align:left;  padding-left: 17px;"};
  h2 {
    font-size: 12px;
    font-family: "GT America, regular";
    text-transform: capitalize;
    font-weight: 300;
  }
  p {
    font-weight: bold;
  }
`;
// export const SwiperSlide = styled.div`
//     /* background: red; */
// `;

export const BackBtn = styled.div`
  position: fixed;
  bottom: 30px;
  max-width: 320px;
  cursor: pointer;
  z-index: 2;
  width: 100%;
  text-align: center;
  font-size: 20px;
  color: #ff3920;
  background: #ffb000;
  box-shadow: 0 15px 10px 0 rgba(50, 7, 91, 0.5);
  border-radius: 30px;
  padding: 15px 0 17px;

  transition: all 0.3s;
  :active {
    box-shadow: none;
    transition: all 0.3s;
  }
`;
